import { mapState } from 'vuex';
import _ from 'lodash';
import moment from 'moment';
import { db } from '@/db';

export default {
  name: 'common-mixin',

  data() {
    return {
      selectedMatchType: 'all',
      accountNeedVerification: false,
    };
  },

  computed: {
    ...mapState([
      'user_data',
      'userType',
      'userMatches',
      'watchUserDataActive',
    ]),

    filteredUserMatches() {
      if (this.selectedMatchType === 'all') {
        return this.userMatches;
      }
      return this.userMatches.filter(m => m.type === this.selectedMatchType);
    },

    filteredPlayerMatches() {
      if (this.selectedMatchType === 'all') {
        return this.userMatches;
      }
      return this.userMatches.filter(m => m.contactByDetails.type === this.selectedMatchType);
    },

    hasLinks() {
      if (!this.user_data.videolinks) {
        return false;
      }
      const hasLinks = this.user_data.videolinks[0].title !== ''
        || this.user_data.videolinks[1].title !== '';
      return hasLinks;
    },

    hasPictures() {
      return this.user_data.galleryImages
        && this.user_data.galleryImages.length > 0
        && (this.user_data.galleryImages[0] !== ''
        || this.user_data.galleryImages[1] !== ''
        || this.user_data.galleryImages[2] !== ''
        || this.user_data.galleryImages[3] !== '');
    },

    hasArticles() {
      if (!this.user_data.newslinks) {
        return false;
      }
      const hasArticles = this.user_data.newslinks[0].title !== ''
        || this.user_data.newslinks[1].title !== '';
      return hasArticles;
    },

    isSubscriptionExpired() {
      const currentDate = moment();

      return this.user_data.leaguePackage && this.user_data.leaguePackage.activeToDate
        ? moment([this.user_data.leaguePackage.activeToDate, 5, 30]) < currentDate
        : false;
    },
  },

  methods: {
    async verifyAccount() {
      await db
        .collection(this.userType)
        .doc(this.user_data.id)
        .update({
          accountNotActivated: false,
        });
      this.accountNeedVerification = false;
    },

    async fetchChats(matches, showSpinner = true) {
      console.log({ matches });
      if (showSpinner) {
        this.$store.state.loading = true;
      }

      let matchData = !matches ? [] : matches;

      if (!matchData.length) {
        console.log('empty match arr');
        this.$store.commit('setUserMatches', []);
        this.$store.state.bindedUserData.noMatch = true;
        this.$store.state.loading = false;
      } else {
        matchData = _.uniq(matchData);
        const tempTeam = matchData
          .map(async match => db
            .collection('matches')
            .doc(match)
            .get({ source: 'server' })
            .then(snapshot => snapshot.data()));

        const results = await Promise.all(tempTeam);
        // filter all undefined if some id are deleted in DB
        // reverse to show newest on front
        this.$store.commit('setUserMatches', results.filter(r => r !== undefined).reverse());

        this.$store.state.loading = false;
      }
    },

    clearLinks() {
      if (this.user_data.fupa) {
        this.user_data.fupa = this.user_data.fupa.replace('https://', '');
      }
      if (this.user_data.transfermarkt) {
        this.user_data.transfermarkt = this.user_data.transfermarkt.replace('https://', '');
      }
      if (this.user_data.facebook) {
        this.user_data.facebook = this.user_data.facebook.replace('https://', '');
      }
      if (this.user_data.instagram) {
        this.user_data.instagram = this.user_data.instagram.replace('https://', '');
      }
      if (this.user_data.website) {
        this.user_data.website = this.user_data.website.replace('https://', '');
      }

      this.user_data.newslinks[0].link = this.user_data.newslinks[0].link.replace('https://', '');
      this.user_data.newslinks[1].link = this.user_data.newslinks[1].link.replace('https://', '');
      this.user_data.videolinks[1].link = this.user_data.videolinks[1].link.replace('https://', '');
      this.user_data.videolinks[0].link = this.user_data.videolinks[0].link.replace('https://', '');
    },

    redirectToUserType(userType) {
      if (userType === 'scout') {
        this.$router
          .push({
            name: this.user_data.fullyFilled ? 'scout_home' : 'scoutUpdate',
          });
      } else if (userType === 'teams') {
        this.$router
          .push({
            name: this.user_data.fullyFilled ? 'team_home' : 'teamUpdate',
          });
      } else if (userType === 'trainers') {
        this.$router
          .push({
            name: this.user_data.fullyFilled ? 'trainer_home' : 'trainerUpdate',
          });
      } else if (userType === 'users') {
        this.$router
          .push({
            name: this.user_data.fullyFilled ? 'home' : 'userUpdate',
          });
      }
    },

    howManyDaysFromLastSwipeUsed() {
      const last = this.user_data.swipesUsedAt;
      const now = Date.now();

      return Math.floor((now - last) / 1000 / 60 / 60 / 24 - 1);
    },
  },
};
